import { Appearance, PrintArea, Size, SizePx } from '@/types';
import { getParams, isAdminMode } from '@/utils/params';
import { convertAndScale } from '@/model/configuration/convertAndScale';
import { rotatedSize as getRotatedSize } from '@/model/configuration/rotatedSize';
import { fitsPrintAreaAndPrintType } from './fitsPrintAreaAndPrintType';
import { getPrintTypesForPrintArea } from './getPrintTypesForPrintArea';
import { isEnlargeable } from './isEnlargeable';
import { isShrinkable } from './isShrinkable';
import { limitPrintTypes } from './limitPrintTypes';

export function printTypesFor(
  printArea: PrintArea,
  appearance: Appearance,
  allowedPrintTypeIds: string[],
  size: Size | SizePx,
  rotation: number,
  scaleForPrintabilityCheck: number,
  isBelowMinimum: boolean,
  allowScale: boolean
) {
  const printableTypes = getPrintTypesForPrintArea(printArea, appearance).filter((pt) => {
    if (!allowedPrintTypeIds.some((id) => id === pt.id)) {
      return false;
    }

    // digital print types always work if the configuration is allowed to scale
    if (isShrinkable(pt) && allowScale) {
      return true;
    }

    // check for line thickness
    if (isEnlargeable(pt) && isBelowMinimum) {
      return false;
    }

    // check that the configuration in its rotated form is both smaller
    // than the print area and the print type
    return fitsPrintAreaAndPrintType(
      getRotatedSize(rotation, convertAndScale(size, scaleForPrintabilityCheck, pt)),
      printArea!,
      pt
    );
  });
  return isAdminMode() || getParams().disablePrintTypeLimitation
    ? printableTypes
    : limitPrintTypes(printableTypes);
}
